import { render } from "./PlayTime.vue?vue&type=template&id=450f02c6&scoped=true"
import script from "./PlayTime.vue?vue&type=script&lang=ts"
export * from "./PlayTime.vue?vue&type=script&lang=ts"

import "./PlayTime.vue?vue&type=style&index=0&id=450f02c6&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-450f02c6"

export default script